import React from 'react';

import { SiderProps } from 'antd';
import Sider from 'antd/lib/layout/Sider';
import styled, { DefaultTheme } from 'styled-components';

export type StyledSiderProps = SiderProps & { theme?: DefaultTheme };

const LightSider: React.FC<StyledSiderProps> = (props) => <Sider {...props} theme="light" />;

export const StyledSider = styled(LightSider)`
  border-right: 1px solid ${(p) => p.theme.light_blue_background};
  background-color: ${(p) => p.theme.dark_blue_background};
  padding: 10px 15px;

  .ant-layout-sider-children {
    height: unset;
    position: sticky;
    top: 50px;
  }

  .ant-layout-sider-trigger {
    background: transparent;
    color: ${(p) => p.theme.white};
  }
`;
